"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_GROUPS_HASH = void 0;
exports.GET_GROUPS_HASH = `
  {
    groups
  }
`;
//# sourceMappingURL=groups-queries.js.map